import * as R from 'ramda'
import * as React from 'react'

import { APP_MALFUNCTION_SETS } from '@ngb-frontend/shared/config'
import { useCountryConfig } from '@ngb-frontend/shared/context'
import { getMalfunctionStepDataFromBooking } from '@ngb-frontend/shared/utils'

import { ContactDirectlyBanner } from '../../ContactDirectlyBanner/ContactDirectlyBanner'
import { MalfunctionForm } from '../../forms/MalfunctionForm/MalfunctionForm'

import type {
  MalfunctionFormValues,
  MalfunctionStepPrerequisiteData,
  MalfunctionStepValues,
  StepProps,
} from '@ngb-frontend/shared/types'

const MalfunctionStep: React.FC<
  StepProps<MalfunctionStepValues, MalfunctionStepPrerequisiteData>
> = ({ onNextStep, onUpdateStep, stepData, booking }) => {
  const countryConfig = useCountryConfig()
  const [showContactBanner, setShowContactBanner] = React.useState(true)
  const initialValuesRef = React.useRef<MalfunctionStepValues | undefined>(
    hasMalfunctionFormValues(stepData)
      ? {
          malfunctions: stepData.malfunctions,
          malfunctionDescription: stepData.malfunctionDescription,
        }
      : booking
      ? getMalfunctionStepDataFromBooking(booking)
      : undefined,
  )

  const handleSubmit = React.useCallback(
    (values: MalfunctionFormValues) => {
      onUpdateStep(values)
      onNextStep()
    },
    [onNextStep, onUpdateStep],
  )

  return (
    <>
      {showContactBanner && (
        <ContactDirectlyBanner
          callLabel
          margin={{ bottom: '08' }}
          onClose={() => setShowContactBanner(false)}
        />
      )}
      <MalfunctionForm
        malfunctions={countryConfig?.malfunctions || APP_MALFUNCTION_SETS}
        onSubmit={handleSubmit}
        initialValues={initialValuesRef.current}
      />
    </>
  )
}

export const hasMalfunctionFormValues = (x: unknown) =>
  R.allPass([
    R.pipe(
      R.prop('malfunctions'),
      R.when(R.is(Object), R.pipe(R.values, R.flatten, R.length)),
    ),
  ])(x) ||
  R.allPass([R.pipe(R.prop('malfunctionDescription'), R.is(String))])(x)

export default MalfunctionStep
